



































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';

@Component
export default class ProfileTab extends Vue {
  @Prop(Boolean) public isOpenAccountDetailDrawer: boolean = false;
  private isMiniAccountDetailDrawer: boolean = false;
  private saiyoFlag: boolean = false;
  private webFlag: boolean = false;
  private techniqueRating2: number = 0;
  private communicationRating2: number = 0;
  private understandingRating2: number = 0;
  private tab = null;
  private rollMouseOver: boolean = false;
  private scrollY: number = 0;
  private scrollReferencePoint: number = 100;
  private isScrollLower: boolean = false;
  private skills = [
    { name: 'Vue.js', year: 10 },
    { name: 'Java', year: 4 },
    { name: 'MySQL', year: 0.8 },
    { name: 'AWS', year: 12 },
    { name: 'Git', year: 4 },
    { name: 'PHP', year: 7 },
    { name: 'Laravel', year: 8 },
    { name: 'HTML', year: 2 },
    { name: 'CSS', year: 5 },
  ];
  /** chipAPI：darkの初期値設定 */
  private isDark: boolean = false;

  private socials = [
    {
      icon: 'mdi-hand-heart',
      color: 'indigo',
      notDisabled: true,
      text: '参画オファー',
    },
    {
      icon: 'mdi-laptop-chromebook',
      color: 'cyan darken-1',
      notDisabled: true,
      text: 'web面談オファーして検討する',
    },
    {
      icon: 'mdi-heart',
      color: 'red lighten-3',
      notDisabled: true,
      text: '気になる',
    },
  ];
  private kari: any = [
    {
      name: 'ロール',
      value: '一般ユーザー',
      saveFlag: false,
      editFlag: false,
      editSaveFlag: false,
      editMode: false,
    },
    {
      name: '所属',
      value: 'プロパー',
      saveFlag: false,
      editFlag: false,
      editSaveFlag: false,
      editMode: false,
    },
    {
      name: '単価',
      value: '50',
      saveFlag: false,
      editFlag: false,
      editSaveFlag: false,
      editMode: false,
    },
    {
      name: '参画開始日',
      value: '2020-04-01',
      saveFlag: false,
      editFlag: false,
      editSaveFlag: false,
      editMode: false,
    },
    {
      name: '参画終了日',
      value: '2020-05-31',
      saveFlag: false,
      editFlag: false,
      editSaveFlag: false,
      editMode: false,
    },
    {
      name: '予定稼働量',
      value: '23',
      saveFlag: false,
      editFlag: false,
      editSaveFlag: false,
      editMode: false,
    },
    {
      name: 'コメント',
      value: 'ここにコメント',
      saveFlag: false,
      editFlag: false,
      editSaveFlag: false,
      editMode: false,
    },
  ];
  private participationConditions = [
    {
      name: 'ロール',
      value: '一般ユーザー',
      saveFlag: false,
      editFlag: false,
      editSaveFlag: false,
      editMode: false,
      selectList: ['組織管理者', 'プロジェクト管理者', '一般ユーザー'],
    },
    {
      name: '所属',
      value: 'プロパー',
      saveFlag: false,
      editFlag: false,
      editSaveFlag: false,
      editMode: false,
      selectList: ['プロパー', 'フリーランス'],
    },
    {
      name: '単価',
      value: '50',
      saveFlag: false,
      editFlag: false,
      editSaveFlag: false,
      editMode: false,
    },
    {
      name: '参画開始日',
      value: '2020-04-01',
      saveFlag: false,
      editFlag: false,
      editSaveFlag: false,
      editMode: false,
    },
    {
      name: '参画終了日',
      value: '2020-05-31',
      saveFlag: false,
      editFlag: false,
      editSaveFlag: false,
      editMode: false,
    },
    {
      name: '予定稼働量',
      value: '23',
      saveFlag: false,
      editFlag: false,
      editSaveFlag: false,
      editMode: false,
    },
    {
      name: 'コメント',
      value: 'ここにコメント',
      saveFlag: false,
      editFlag: false,
      editSaveFlag: false,
      editMode: false,
    },
  ];

  private qualifications = [
    {
      name: '基本情報技術者',
    },
    {
      name: 'Oracle Certified Java Programmer, Silver SE 8',
    },
  ];
  private activityList = [
    {
      title: '課題を追加しました。',
      content:
        'THEORY-28 Gitとのデータ連携テストを行う。Gitとのデータ連携のテストを行う。テスト実装を行い、セオリーで必要なGit機能を満たすための連携実験を機能毎（例：API毎）に行う。',
    },
    {
      title: '課題を追加しました。',
      content:
        'THEORY-28 Gitとのデータ連携テストを行う。Gitとのデータ連携のテストを行う。テスト実装を行い、セオリーで必要なGit機能を満たすための連携実験を機能毎（例：API毎）に行う。',
    },
    {
      title: '課題を追加しました。',
      content:
        'THEORY-28 Gitとのデータ連携テストを行う。Gitとのデータ連携のテストを行う。テスト実装を行い、セオリーで必要なGit機能を満たすための連携実験を機能毎（例：API毎）に行う。',
    },
    {
      title: '課題を追加しました。',
      content:
        'THEORY-28 Gitとのデータ連携テストを行う。Gitとのデータ連携のテストを行う。テスト実装を行い、セオリーで必要なGit機能を満たすための連携実験を機能毎（例：API毎）に行う。',
    },
    {
      title: '課題を追加しました。',
      content:
        'THEORY-28 Gitとのデータ連携テストを行う。Gitとのデータ連携のテストを行う。テスト実装を行い、セオリーで必要なGit機能を満たすための連携実験を機能毎（例：API毎）に行う。',
    },
  ];

  /**
   * 所有スキルの経験年数に応じてchipの背景を変える関数
   * 引数：経験年数
   * 返り値：背景色
   */
  private chipColor(experienceYears: number): string {
    if (experienceYears >= 10) {
      return 'light-blue darken-4';
    }
    if (experienceYears >= 5) {
      return 'light-blue';
    }
    if (experienceYears >= 3) {
      return 'light-blue lighten-3';
    }
    if (experienceYears >= 1) {
      return 'light-blue lighten-5';
    }
    return 'blue-grey lighten-5';
  }

  /**
   * 所有スキルの経験年数に応じてchipの文字色を変える関数
   * 引数：経験年数
   * 返り値：chipAPI：darkのboolean
   */
  private isDarkChip(experienceYears: number): boolean {
    if (experienceYears >= 5) {
      return true;
    } else {
      return false;
    }
  }

  private clickedActionButton(notDisabled: boolean, icon: string) {
    const selectContent = this.socials.find((x) => x.icon === icon);
    if (selectContent) {
      if (notDisabled) {
        selectContent.notDisabled = false;
      } else {
        selectContent.notDisabled = true;
      }
    }
  }

  private color(color: string, notDisabled: boolean) {
    if (notDisabled) {
      return 'white';
    } else {
      return color;
    }
  }

  private mounted() {
    const targetElement = document.getElementById('scrollBarTarget');
    if (targetElement) {
      targetElement.addEventListener('scroll', this.handleScroll);
    }
  }
  private handleScroll() {
    const targetElement = document.getElementById('scrollBodyTarget');
    if (targetElement) {
      const clientRect = targetElement.getBoundingClientRect();
      this.scrollY = clientRect.top;
    }
    if (this.scrollY < this.scrollReferencePoint) {
      this.isScrollLower = true;
    } else {
      this.isScrollLower = false;
    }
  }

  private test2() {
    for (const a of this.kari) {
      for (const b of this.participationConditions) {
        if (a.name === b.name) {
          if (a.value !== b.value) {
            b.editFlag = true;
          } else {
            b.editFlag = false;
          }
        }
      }
    }
  }

  private save() {
    for (const participationCondition of this.participationConditions) {
      if (participationCondition.editFlag) {
        participationCondition.saveFlag = true;
        participationCondition.editFlag = false;
        setTimeout(this.checkIconDelete, 1500);
      }
    }
  }

  private a() {
    if (this.isScrollLower) {
      return 50;
    } else {
      return 100;
    }
  }

  private checkIconDelete() {
    for (const participationCondition of this.participationConditions) {
      if (participationCondition.saveFlag) {
        participationCondition.saveFlag = false;
      }
    }
  }

  @Emit('miniAccountDetailDrawer')
  private miniAccountDetailDrawer() {
    this.isMiniAccountDetailDrawer = true;
  }

  @Emit('openAccountDetailDrawer')
  private openAccountDetailDrawer() {
    this.isOpenAccountDetailDrawer = false;
  }

  @Emit('closeAccountDetailDrawer')
  private closeAccountDetailDrawer() {
    this.isOpenAccountDetailDrawer = false;
    this.isMiniAccountDetailDrawer = false;
  }
}
